"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const yup_rules_1 = require("@framework/yup-rules");
const textarea_1 = require("../textarea");
const JsonInput = props => {
    const { name, readOnly, ...rest } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const normalizeValue = (value) => {
        try {
            return JSON.stringify(JSON.parse(value), null, "\t");
        }
        catch (_e) {
            return value;
        }
    };
    const inputProps = {
        onBlur: (event) => {
            const { value } = event.target;
            if (readOnly) {
                return;
            }
            try {
                // needs to set touched for this field to true
                form.setValue(name, value, { shouldTouch: true });
                yup_rules_1.jsonValidationSchema.validateSync(value);
                const formattedValue = normalizeValue(value);
                event.target.value = formattedValue;
                form.setValue(name, formattedValue);
                form.clearErrors(name);
            }
            catch (e) {
                form.setError(name, { type: "custom", message: e.message }, { shouldFocus: true });
            }
        },
        onFocus: () => form.setFocus(name),
    };
    return (0, jsx_runtime_1.jsx)(textarea_1.TextArea, { name: name, normalizeValue: normalizeValue, ...inputProps, readOnly: readOnly, ...rest });
};
exports.JsonInput = JsonInput;
//# sourceMappingURL=index.js.map